import { type ReactElement } from 'react';
import { layoutMeasures } from '@/theme/layoutMeasures';
import { resolveSemanticColor } from '@/theme/semanticTokens';
import { Box, PageShell, Stack, StatusBanner, Surface, Text } from '@/ui';

const fallbackContentTextSx = { fontSize: '15px' };

export const FatalConfigScreen = ({ errors }: { errors: string[] }): ReactElement => (
  <Box
    sx={{
      minHeight: layoutMeasures.viewport.fullHeight,
      display: 'grid',
      placeItems: 'center',
      background: (theme) => resolveSemanticColor(theme, 'pageMutedBg'),
    }}
  >
    <PageShell maxWidth="sm" paddingX="lg" paddingY="lg">
      <Surface padding="lg">
        <Stack gap="md" align="stretch">
          <Text role="pageTitle">Configuration error</Text>
          <StatusBanner
            tone="red"
            message="Please set the required environment variables and reload."
          />
          {errors.map((err) => (
            <StatusBanner key={err} tone="red" dense message={err} />
          ))}
          <Text role="body" color="textSecondary" sx={fallbackContentTextSx}>
            Required: VITE_API_BASE_URL (URL). Optional: VITE_ADMIN_USER_ID,
            VITE_SESSION_MAX_AGE_MINUTES.
          </Text>
        </Stack>
      </Surface>
    </PageShell>
  </Box>
);
